import Customer from "./Customer";
import type { ICustomer } from "./Customer";
import Product from "./Product";
import type { IProduct } from "./Product";
import ProductAnswer from "./ProductAnswer";
import type { IProductAnswer } from "./ProductAnswer";

export interface IProductQuestion {
  id?: string;
  question?: string;
  is_approved: boolean;
  product?: IProduct;
  customer?: ICustomer;
  answers?: IProductAnswer[];
  created_at_text?: string;
}

export class ProductQuestion implements IProductQuestion {
  public type = "product-questions";
  public relationshipNames = ["customer", "product", "answers"];

  public id?: string;
  public question?: string;
  public is_approved: boolean = false;
  public product?: Product;
  public customer?: Customer;
  public answers?: ProductAnswer[] = [];
  public created_at_text?: string;

  public constructor(data?: IProductQuestion) {
    if (data) {
      this.fill(data);
    }
  }

  public fill(data: IProductQuestion) {
    this.id = data.id;
    this.question = data.question;
    this.is_approved = data.is_approved;
    this.created_at_text = data.created_at_text;
    this.product = data.product ? new Product(data.product) : undefined;
    this.customer = data.customer ? new Customer(data.customer) : undefined;
    this.answers = Array.isArray(data.answers)
      ? ProductAnswer.fromArray(data.answers)
      : undefined;
  }

  public static fromArray(items: IProductQuestion[]) {
    return items.map((item) => new ProductQuestion(item));
  }
}
